import { Link } from "react-router-dom";
import { featuredAnime } from "@/mocks/anime";

export default function FeaturedAnime() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">精选推荐</h2>
          <p className="text-sm text-foreground-600 mt-2">编辑精选，不容错过的热门动漫</p>
        </div>
        <Link to="/category/japanese" className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {featuredAnime.map((anime, index) => (
          <Link
            key={anime.id}
            to={`/article/${anime.id}`}
            className="group cursor-pointer"
          >
            <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
              <img
                src={anime.coverImage}
                alt={anime.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                title={`${anime.title} - 51动漫在线观看`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              {index === 0 && (
                <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs font-bold px-2 py-0.5 rounded-md">
                  HOT
                </div>
              )}
              <div className="absolute bottom-2 left-2 right-2">
                <div className="flex items-center gap-1 text-white/90 text-xs">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  <span>{anime.rating}</span>
                  <span className="mx-1 text-white/40">·</span>
                  <span>{anime.episodeCount}</span>
                </div>
              </div>
            </div>
            <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
              {anime.title}
            </h3>
          </Link>
        ))}
      </div>
    </section>
  );
}